import { PlanConcreteTargets } from '../generated/PlanConcreteTargets';
import { PlanTarget } from '../generated/PlanTarget';
import { SupportPlan } from '../generated/SupportPlan';

export class SupportPlanDTO {
  support_plan: SupportPlan = new SupportPlan();
  plan_targets: PlanTarget[] = [];
  plan_concrete_targets: PlanConcreteTargets[] = [];
  student_name = '';
}
